import { createSlice } from "@reduxjs/toolkit";
import { RESET } from "../types";

const initialState = {
  merchantIfoodIds: undefined,
  isIfoodWidgetInitialized: false,
  showMerchantSetupModal: false,
};

const merchantsSlice = createSlice({
  name: "merchants",
  initialState,
  reducers: {
    setMerchantIfoodIds: (state, action) => {
      state.merchantIfoodIds = action.payload;
    },
    setIsIfoodWidgetInitialized: (state, action) => {
      state.merchantIfoodIds = action.payload;
    },
    setShowMerchantSetupModal: (state, action) => {
      state.showMerchantSetupModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET, () => initialState);
  },
});

export const {
  setMerchantIfoodIds,
  setIsIfoodWidgetInitialized,
  setShowMerchantSetupModal,
} = merchantsSlice.actions;
export default merchantsSlice.reducer;
